var ipAllowed = {
  redirectHost: 'www.merlo.com.au',
  apiDomain: null,
  init: function init() {
    if (settings.env === 'prod' || location.hostname === '127.0.0.1') {
      // IP whitelist not checked on production.
      return;
    }
    this.apiDomain = settings.apiDomain;
    this.checkAllowed();
  },
  checkAllowed: function checkAllowed() {
    var _this = this;
    this.apiCheckAllowed().then(function (code) {
      console.log(code);
      if (code !== 200 && window.Shopify.designMode !== true) {
        console.log("Code is ".concat(code, ", so we should bounce you away."));
        window.location.hostname = _this.redirectHost; //error, like a 404, so send them away.
      }
    }).catch(function (error) {
      console.log("Error, so we should bounce you away.", error);
      return;
      if (window.Shopify.designMode !== true) {
        window.location.hostname = _this.redirectHost; //error, like a 404, so send them away.
      }
    });
  },

  apiCheckAllowed: function apiCheckAllowed() {
    var _this2 = this;
    return new Promise(function (resolve, reject) {
      console.log("this.apiDomain: ".concat(_this2.apiDomain));
      if (!_this2.apiDomain) {
        return resolve(200);
      }
      fetch("".concat(_this2.apiDomain, "/health"), {
        method: 'GET'
      }).then(function (response) {
        if (response) {
          return resolve(response.status);
        } else {
          return resolve(404);
        }
      }).catch(function (error) {
        return resolve(404);
      });
    });
  }
};
jQuery(function () {
  ipAllowed.init();
});